/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ExpireParticipationsResponseDto } from '../model';
/**
 * SchedulerApi - axios parameter creator
 * @export
 */
export const SchedulerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Expire pending participations older than specified minutes
         * @param {number} [minutesAgo] Number of minutes to look back (default: 20)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerControllerExpirePendingParticipations: async (minutesAgo?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scheduler/expire-participations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (minutesAgo !== undefined) {
                localVarQueryParameter['minutesAgo'] = minutesAgo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchedulerApi - functional programming interface
 * @export
 */
export const SchedulerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchedulerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Expire pending participations older than specified minutes
         * @param {number} [minutesAgo] Number of minutes to look back (default: 20)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulerControllerExpirePendingParticipations(minutesAgo?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExpireParticipationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulerControllerExpirePendingParticipations(minutesAgo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.schedulerControllerExpirePendingParticipations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SchedulerApi - factory interface
 * @export
 */
export const SchedulerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchedulerApiFp(configuration)
    return {
        /**
         * 
         * @summary Expire pending participations older than specified minutes
         * @param {number} [minutesAgo] Number of minutes to look back (default: 20)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulerControllerExpirePendingParticipations(minutesAgo?: number, options?: RawAxiosRequestConfig): AxiosPromise<ExpireParticipationsResponseDto> {
            return localVarFp.schedulerControllerExpirePendingParticipations(minutesAgo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchedulerApi - object-oriented interface
 * @export
 * @class SchedulerApi
 * @extends {BaseAPI}
 */
export class SchedulerApi extends BaseAPI {
    /**
     * 
     * @summary Expire pending participations older than specified minutes
     * @param {number} [minutesAgo] Number of minutes to look back (default: 20)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public schedulerControllerExpirePendingParticipations(minutesAgo?: number, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).schedulerControllerExpirePendingParticipations(minutesAgo, options).then((request) => request(this.axios, this.basePath));
    }
}

